export default __webpack_public_path__ + "static/media/NoFavStands.dc0ae8af.png";